import React from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';

/**
 * Componente Modal genérico.
 * @param {object} props
 * @param {boolean} props.isOpen Controla a visibilidade do modal.
 * @param {Function} props.onClose Função para fechar o modal.
 * @param {string} props.title O título do modal.
 * @param {React.ReactNode} props.children O conteúdo a ser exibido dentro do modal.
 */
const Modal = ({ isOpen, onClose, title, children }) => {
    if (!isOpen) return null;

    const handleBackdropClick = (e) => {
        if (e.target.id === 'modal-backdrop') {
            onClose();
        }
    };
    
    // Renderiza o modal usando um portal no corpo do documento
    return createPortal(
        <div 
            id="modal-backdrop"
            onClick={handleBackdropClick}
            className="fixed inset-0 bg-black bg-opacity-50 dark:bg-gray-900 dark:bg-opacity-75 flex items-center justify-center z-[100] transition-opacity duration-300"
        >
            <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl w-full max-w-xl mx-4 transform transition-transform duration-300 scale-100">
                {/* Cabeçalho do modal */}
                <div className="flex justify-between items-center p-4 border-b border-gray-200 dark:border-gray-700">
                    <h3 className="text-lg font-semibold text-gray-800 dark:text-white">{title}</h3>
                    <button onClick={onClose} className="text-gray-500 hover:text-gray-800 dark:text-gray-400 dark:hover:text-white transition-colors duration-200">
                        <X size={24} />
                    </button>
                </div>
                
                {/* Conteúdo do modal */}
                <div className="p-4">
                    {children}
                </div>
            </div>
        </div>,
        document.body
    );
};

export default Modal;
